import React, { useEffect } from 'react'

export default function ValgAfKoereskole() {
  useEffect(() => {
    document.title = 'Valg af køreskole til elever fra Kalundborg | Tilmeld dig i dag'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Gode råd før du vælger køreskole. Læs mere om kvalitet, priser og klageadgang.'
      )
    }
  }, [])

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              Valg af køreskole
            </h1>
            <p className="mt-2 text-slate-900 font-bold text-lg">
              Gode råd før du vælger køreskole
            </p>
            <p className="mt-1 text-slate-700">
              Der er en række faktorer, der er gode at overveje, før du vælger køreskole.
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Dyrt at købe billigt
              </h2>
              <p>
                Når du skal tage kørekort, handler det om at vælge en skole, der lærer dig at køre sikkert. Som ny bilist skal du klædes bedst muligt på, når du tager kørekort. Pris og kvalitet hænger ofte sammen, så lad dig ikke friste af prisen alene. Den store priskonkurrence køreskolerne imellem giver meget svingende kvalitet i undervisningen.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Lyt til andres anbefalinger
              </h2>
              <p>
                Det er altid en god idé at lytte til andres erfaringer. Hvis du kender én, der har været glad for sin kørerlærer, er der sandsynlighed for, at du også bliver det.
              </p>
              <p>
                (Hos mig har du mulighed for at gå på facebook og se om der er nogen af mine tidligere eller nuværende elever du kender og kan spørge).
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Tal med kørelæreren
              </h2>
              <p>
                Det er en tillidssag at tage kørekort. Derfor er det en god ide at tale med kørelæreren, inden du går i gang med at tage kørekort. Tag stilling til, om vedkommende virker fornuftig og seriøs.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Find ud af, hvad prisen omfatter
              </h2>
              <p>
                Mange steder kan du købe en startpakke. Sæt dig ind i, hvad den indeholder. Undersøg om pakken indeholder de obligatoriske timer, der kræves, for at du kan gå til køreprøve, om prøvegebyr og leje af bil under praktiskprøve også er med, ellers kan det blive dyrere end først antaget. Hos mig indeholder lovpakken den nødvendige undervisning.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Du kan skifte kørelærer undervejs
              </h2>
              <p>
                Du kan være uheldig og ikke være tilfreds med undervisningen. Du har altid mulighed for at skifte til en anden køreskole. Du kan dog få problemer med at få penge tilbage, hvis du har købt et pakketilbud.
              </p>
              <p>
                Tal evt. med køreskolen om dette.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="font-header text-xl font-bold text-slate-900 border-b border-slate-200 pb-2">
                Klage over køreundervisning
              </h2>
              <p>
                Er du ikke tilfreds med din køreundervisning, kan du klage til Ankenævn for køreundervisning{' '}
                <a
                  href="http://www.ankesag.dk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-700 font-bold hover:underline"
                >
                  http://www.ankesag.dk/
                </a>{' '}
                Ankenævnet behandler sager fra alle kørelærere i Danmark. Det koster 150 kr. at klage. Pengene får du igen, hvis du får ret eller delvist medhold.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
